import React from "react";

import { useNavigate } from "react-router-dom";

import _ from "lodash";

import { useRedirectMapContext } from "commons/context/redirectMap";
import { useRouteContext } from "commons/context/route";

import { makeUrl } from "commons/utils/http";
import { checkUserAuthorities } from "commons/utils/utils";

function RedirectMap() {
    const navigate = useNavigate();

    const routeContext = useRouteContext();
    const redirectMapContext = useRedirectMapContext();

    React.useEffect(() => {
        if (routeContext.children) {
            _.forEach(routeContext.children, (child) => {
                if (
                    checkUserAuthorities(
                        redirectMapContext.userAuthorities,
                        child.neededAuthorities,
                        child.oneOf
                    )
                ) {
                    navigate(`${routeContext.path}/${makeUrl(child.path, child.pathParams)}`, {
                        replace: true,
                    });

                    return false;
                }
            });
        }
    }, [navigate, redirectMapContext.userAuthorities, routeContext]);

    return null;
}

export default RedirectMap;
